import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-approveemployeepopup',
  templateUrl: './approveemployeepopup.component.html',
  styleUrls: ['./approveemployeepopup.component.scss'],
})
export class ApproveemployeepopupComponent  implements OnInit {

  
    msg: string = '';
    msgTitle: string = '';
    button1: any;
    button2: any;
    color: any;
    showSuccessIcon: boolean = false;
    showSuccessMessage: boolean = false;
    showCloseIcon: boolean = false
    errorMsg:any = [];
    button3: any;
    action: any;
    observationActionStatus: any;
    observationId: any;
    button4: any;
    auditNumberId: any;
    auditActionStatus: any;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ApproveemployeepopupComponent>,public dialog: MatDialog,) { }
  
    ngOnInit() {
      this.msgTitle = this.data?.msgTitle;
      this.msg = this.data?.msg;
      this.button1 = this.data?.btn1;
      this.button2 = this.data?.btn2;
      this.color = this.data?.btn2BgColor;
      this.showSuccessIcon = this.data?.showSuccessIcon;
      this.showSuccessMessage = this.data?.showSuccessMessage;
      this.showCloseIcon = this.data?.showCloseIcon;
    }
    btn1Action(){
      this.dialogRef.close(false);
    }
    btn2Action(){
      this.dialogRef.close(true);
    }

}
